export default __webpack_public_path__ + "static/media/home-black-24dp.3abf9880.svg";